<template>
    <div class="download-manager" :style="{'padding': downloading.length > 0 ? '10px' : 0}">

        <div v-for="file in downloading">
            <div class="file-wrapper">
                <div class="filename">
                    {{file.name}}
                </div>
          
            <div class="steps">
                <div class="step" :class="{'active': file.activeStep ==='downloading'}">
                    <div class="step-label">
                        Transferring:
                    </div>
                    <div class="bar-wrapper">
                        <span :class="{'dark': file.downloadPercentage > 45}">{{file.downloadPercentage}}%</span>
                        <div class="bar" :style="{'width': file.downloadPercentage + '%'}">
                        </div>
                    </div>
                </div>
                <div class="step" :class="{'active': file.activeStep  ==='processing'}">
                    <div class="step-label">
                        Processing:
                    </div>
                    <div class="bar-wrapper">
                        <span :class="{'dark': file.processedPercentage > 45}">{{file.processedPercentage}}%</span>
                        <div class="bar" :style="{'width': file.processedPercentage + '%'}">
                        </div>
                    </div>
                </div>
                <div class="step" :class="{'active': file.activeStep  ==='archiving'}">
                    <div class="step-label">
                        Archiving:
                    </div>
                    <div class="bar-wrapper">
                        <span :class="{'dark': file.archivedPercentage > 45}">{{file.archivedPercentage}}%</span>
                        <div class="bar" :style="{'width': file.archivedPercentage + '%'}">
                        </div>
                    </div>
                </div>                
                <div class="step" :class="{'active': file.activeStep ==='finalizing'}">
                    <div class="step-label">
                        Finalizing:
                    </div>
                    <div class="bar-wrapper">
                        <span :class="{'dark': file.finalizedPercentage > 45}">{{file.finalizedPercentage}}%</span>
                        <div class="bar" :style="{'width': file.finalizedPercentage + '%'}">
                        </div>
                    </div>
                </div>            
            </div>   
              </div>
        </div>
        <i v-if="downloading.length > 0 && allFilesDownloaded" class="fa fa-close close-download-widget" @click="closeDownloads()"></i>
    </div>
</template>
<script>

import toastr from 'toastr';
import FileSaver from '../../../../node_modules/file-saver/dist/FileSaver.js';

import files from '../../../services/files';

export default {
    data() {
        return {
            downloading: []
        }
    },
    components: {

    },
    mounted() {

        this.$bus.$on('download', (url, type, id, source)=>{
            
            const browserId = this.$store.state.browserId;
            const filename = url.split('/').pop();
            const exists = this.downloading.find(f => f.name === filename);
            if (exists) return;
            files.download(url, type, id, browserId, source).then((response)=> {
                if (response.data.success === false) {
                    toastr.error(response.data.message);
                }
            });           
        });
        
        this.sockets.subscribe('file_started', ({ filename }) => {
            let file = this.downloading.findIndex(f => f.name === filename);
            if (file === -1) {
                this.addFile(filename, 'downloading');            
            }
        });

        this.sockets.subscribe('file_progress', ({ filename, total, received }) => {                        
            let file = this.downloading.findIndex(f => f.name === filename);
            if (file === -1) {
                this.addFile(filename, 'downloading');            
                file = this.downloading.findIndex(f => f.name === filename);
            }

            this.downloading[file].downloadPercentage = Math.round((received * 100) / total);

            if (this.downloading[file].downloadPercentage >= 100) {
                this.downloading[file].downloadPercentage = 100;
                this.downloading[file].activeStep = 'processing';
                this.downloading[file].processedPercentage = 1;
            }
        });

        this.sockets.subscribe('files_processed', ({ filename, total, done }) => {
            
            let file = this.downloading.findIndex(f => f.name === filename);
            if (file === -1) {
                this.addFile(filename, 'processing');                
                file = this.downloading.findIndex(f => f.name === filename);
                this.downloading[file].downloadPercentage = 100;
                this.downloading[file].processedPercentage = 1;
            } 

            const processed = Math.round((done * 100) / total);
            if (processed > 1) {
                this.downloading[file].processedPercentage = processed;
                this.downloading[file].downloadPercentage = 100;
            }
            if (this.downloading[file].processedPercentage >= 100) {
                this.downloading[file].processedPercentage = 100;
                this.downloading[file].archivedPercentage = 1;
                this.downloading[file].activeStep = 'archiving';
            }
        });

        this.sockets.subscribe('file_archived', ({ filename, total, done }) => {
            
            let file = this.downloading.findIndex(f => f.name === filename);
            if (file === -1) {
                this.addFile(filename, 'archiving');                
                file = this.downloading.findIndex(f => f.name === filename);
                this.downloading[file].processedPercentage = 100;
                this.downloading[file].archivedPercentage = 1;

            }

            const archived = Math.round((done * 100) / total);
            if (archived > 1) {
                this.downloading[file].archivedPercentage = archived;
            }
            if (this.downloading[file].archivedPercentage >= 100) {
                this.downloading[file].archivedPercentage = 100;
                this.downloading[file].finalizedPercentage = 1;
                this.downloading[file].activeStep = 'finalizing';
            }
        });


        this.sockets.subscribe('file_finalized', ({ filename, total, done }) => {
           
            let file = this.downloading.findIndex(f => f.name === filename);
            if (file === -1) {
                this.addFile(filename, 'finalizing');
                file = this.downloading.findIndex(f => f.name === filename);
                this.downloading[file].downloadPercentage = 100;
                this.downloading[file].processedPercentage = 100;
                this.downloading[file].archivedPercentage = 100;
                this.downloading[file].finalizedPercentage = 1;

            }

            const finalized = Math.round((done * 100) / total);
            if (finalized > 1) {
                this.downloading[file].activeStep = 'finalizing';
                this.downloading[file].finalizedPercentage = finalized;
                if (this.downloading[file].processedPercentage < 100) {
                    this.downloading[file].processedPercentage = 100;
                }

            }
            if (this.downloading[file].finalizedPercentage >= 100) {
                this.downloading[file].finalizedPercentage = 100;
            }
        });

        this.sockets.subscribe('processed_file_finished', ({ filename, url }) => {   

            var a = document.createElement("a");
            a.setAttribute('href', url);
            a.setAttribute('download', filename);
              
            a.click();

        });
        this.sockets.subscribe('hide_download_widget', ({ filename, url }) => {   

            const file = this.downloading.findIndex(f => f.name === filename);
            if (file > -1) {
                this.downloading.splice(file, 1);
            }
            this.$forceUpdate();
           
        });
    },

    methods: {
        closeDownloads() {
            this.downloading = [];
        },
        addFile(filename, step) {                      
            const file = {
                activeStep: step,
                name: filename,
                downloadPercentage: 0,
                processedPercentage: 0,
                archivedPercentage: 0,
                finalizedPercentage: 0
            }            
            this.downloading.push(file);
        }
    },
    computed: {
        allFilesDownloaded() {
            let stillDownloading = true;
            this.downloading.forEach((file)=> {
                if (file.finalizedPercentage >= 100) {
                    stillDownloading = false;
                }
            });
            return !stillDownloading;
        }
    },

}

</script>
<style lang="scss" scoped>
.close-download-widget {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    margin-right: 3px;
}
.notice {
    text-align: center;
    margin-top:10px;
    font-size:12px;
}
.download-manager {
    background: #333;
    width: 650px;    
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999999;  
    border-right:1px solid rgba(255,255,255,.2);
    padding:10px;
    .file-wrapper {
        display: flex;
        align-items: center;
        .filename {
            width:40%;
            padding-left:5px;
            overflow:hidden;
            text-overflow:ellipsis;
        }
    }
    .steps {
        display:flex;
        flex-direction:row;
        width:60%;
        justify-content:space-around;
    }
    .step {        
        display:flex;
        align-items: center;
        font-size:16px;
        border-bottom:1px solid rgba(255,255,255,.2);
        flex-direction:column;
        &.active .step-label {
            font-weight:700;
            animation-duration: 3s;
            animation-fill-mode: both;
            animation-iteration-count: infinite;
            animation-name: pulse;
            animation-timing-function: ease-in-out;
            color:#fff;
        }
    }
    .step-label {
        font-weight:normal;
        text-align:left;
        font-size:14px;
        width:100%;
    }
    .bar-wrapper {
        width:100%;
        position:relative;
        height:2rem;
        display:flex;
        align-items:center;
        justify-content:center;        
    }
    .bar {
        height: 100%;
        background: #3df;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999999999;
        display:flex;
        align-items: center;
        justify-content:center;
        color:#333;
        z-index:1;
    }
    .dark {
        color:#333;
        z-index:99999;
    }
}

@keyframes pulse {
  from {
    transform: scale3d(1, 1, 1);
  }

  50% {
    transform: scale3d(1.05, 1.05, 1.05);
  }

  to {
    transform: scale3d(1, 1, 1);
  }
}


</style>



// WEBPACK FOOTER //
// DownloadManager.vue?4fa2ef35